import { USER_JURISDICTION_UPDATED } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';
import { Jurisdiction } from '@gig/magic-jurisdictions/dist/jurisdictions.constants';
import { JurisdictionCommonService } from './jurisdiction.utils.js';

var JURISDICTION_FORM_QUERY = 'jurisdiction:form:query';
var JurisdictionModulesService = /** @class */ (function () {
    function JurisdictionModulesService(countryToJurisdiction, defaultJurisdiction) {
        var _this = this;
        this.modules = {};
        var service = new JurisdictionCommonService(countryToJurisdiction, defaultJurisdiction);
        if (this.isModular(service.defaultJurisdiction)) {
            this.setupModule(service.defaultJurisdiction);
        }
        window.eventBus.subscribe(USER_JURISDICTION_UPDATED, function (event) {
            if (_this.jurisdiction && _this.isModular(_this.jurisdiction)) {
                _this.destroyModule(_this.jurisdiction);
            }
            _this.jurisdiction = event.payload;
            if (_this.isModular(_this.jurisdiction)) {
                _this.setupModule(_this.jurisdiction);
            }
        }, { replay: true, distinct: true });
        window.queryBus.subscribe(JURISDICTION_FORM_QUERY, function (event) { return __awaiter(_this, void 0, void 0, function () {
            var nextButtonEnabled;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        nextButtonEnabled = !!((_a = event.payload) === null || _a === void 0 ? void 0 : _a.nextButtonEnabled);
                        return [4 /*yield*/, this.getJurisdictionFormConfig(nextButtonEnabled)];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        }); });
    }
    JurisdictionModulesService.prototype.setupModule = function (jurisdiction) {
        return __awaiter(this, void 0, void 0, function () {
            var module;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getModule(jurisdiction)];
                    case 1:
                        module = _a.sent();
                        module.setup();
                        return [2 /*return*/];
                }
            });
        });
    };
    JurisdictionModulesService.prototype.destroyModule = function (jurisdiction) {
        return __awaiter(this, void 0, void 0, function () {
            var module;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getModule(jurisdiction)];
                    case 1:
                        module = _a.sent();
                        module.destroy();
                        return [2 /*return*/];
                }
            });
        });
    };
    JurisdictionModulesService.prototype.getJurisdictionFormConfig = function (nextButtonEnabled) {
        return __awaiter(this, void 0, void 0, function () {
            var module_1, module;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.jurisdiction && this.isModular(this.jurisdiction))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getModule(this.jurisdiction)];
                    case 1:
                        module_1 = _a.sent();
                        return [2 /*return*/, module_1.signUpFormConfig(nextButtonEnabled)];
                    case 2: return [4 /*yield*/, import(
                        /* webpackChunkName: "account" */ '@gig/magic-jurisdictions/dist/configs')];
                    case 3:
                        module = _a.sent();
                        if (this.jurisdiction === Jurisdiction.UKGC) {
                            return [2 /*return*/, module.UKGCSignupFormConfig(nextButtonEnabled)];
                        }
                        return [2 /*return*/, module.defaultSignupFormConfig(nextButtonEnabled)];
                }
            });
        });
    };
    JurisdictionModulesService.prototype.getModule = function (jurisdiction) {
        return __awaiter(this, void 0, void 0, function () {
            var module, _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        module = this.modules[jurisdiction];
                        if (module) {
                            return [2 /*return*/, module];
                        }
                        if (!(jurisdiction === Jurisdiction.AGCO)) return [3 /*break*/, 2];
                        _a = this.modules;
                        _b = jurisdiction;
                        return [4 /*yield*/, import(
                            /* webpackChunkName: "agco" */ '@gig/magic-agco')];
                    case 1:
                        _a[_b] = _l.sent();
                        _l.label = 2;
                    case 2:
                        if (!(jurisdiction === Jurisdiction.LOTBA)) return [3 /*break*/, 4];
                        _c = this.modules;
                        _d = jurisdiction;
                        return [4 /*yield*/, import(
                            /* webpackChunkName: "lotba" */ '@gig/magic-lotba')];
                    case 3:
                        _c[_d] = _l.sent();
                        _l.label = 4;
                    case 4:
                        if (!(jurisdiction === Jurisdiction.ONJN)) return [3 /*break*/, 6];
                        _e = this.modules;
                        _f = jurisdiction;
                        return [4 /*yield*/, import(
                            /* webpackChunkName: "onjn" */ '@gig/magic-onjn')];
                    case 5:
                        _e[_f] = _l.sent();
                        _l.label = 6;
                    case 6:
                        if (!(jurisdiction === Jurisdiction.EMTA)) return [3 /*break*/, 8];
                        _g = this.modules;
                        _h = jurisdiction;
                        return [4 /*yield*/, import(
                            /* webpackChunkName: "emta" */ '@gig/magic-emta')];
                    case 7:
                        _g[_h] = _l.sent();
                        _l.label = 8;
                    case 8:
                        if (!(jurisdiction === Jurisdiction.PAGCOR)) return [3 /*break*/, 10];
                        _j = this.modules;
                        _k = jurisdiction;
                        return [4 /*yield*/, import(
                            /* webpackChunkName: "pagcor" */ '@gig/magic-pagcor')];
                    case 9:
                        _j[_k] = _l.sent();
                        _l.label = 10;
                    case 10: return [2 /*return*/, this.modules[jurisdiction]];
                }
            });
        });
    };
    JurisdictionModulesService.prototype.isModular = function (jurisdiction) {
        return (jurisdiction === Jurisdiction.AGCO ||
            jurisdiction === Jurisdiction.LOTBA ||
            jurisdiction === Jurisdiction.ONJN ||
            jurisdiction === Jurisdiction.EMTA);
    };
    return JurisdictionModulesService;
}());

export { JURISDICTION_FORM_QUERY, JurisdictionModulesService };
